import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import SiteSpeedLayout from "../../components/SiteSpeed/SiteSpeedLayout";
import { fetchLoadingTime } from "../../store/loading_time/operations";
import { fetchMonitorLocations } from "../../store/monitor_locations/operations";
import { getSelectedWebsiteUrl, getSelectedWebsiteRegions } from "../../store/tracked_websites/selectors";
import {
  getDefaultInterval,
  getIntervals,
  getSelectedInterval,
  getSelectedRegion,
  getSelectedIntervalLoadingTimeData,
  isFetchingLoadingData
} from "../../store/loading_time/selectors";
import { changeSelectedInterval, changeSelectedRegion } from "../../store/loading_time/creators";
import { getMonitorLocations } from "../../store/monitor_locations/selectors";

class SiteSpeed extends Component {
  componentDidMount() {
    this.props.fetchMonitorLocations();
    this.props.changeSelectedRegion(this.props.url, this.props.regions[0]);
    this.props.changeSelectedInterval(this.props.url, this.props.defaultInterval);

    const currentDate = moment().utc();
    const endDateStr = currentDate.format("YYYY-MM-DDTHH:mm:ss");
    const endDate = moment(endDateStr);
    const startDateStr = endDate.subtract(24, "hours").format("YYYY-MM-DDTHH:mm:ss");
    const groupBy = "hour";

    this.props.fetchLoadingTime(
      this.props.url,
      this.props.regions[0],
      this.props.defaultInterval,
      startDateStr,
      endDateStr,
      groupBy
    );
  }
  render() {
    return (
      <SiteSpeedLayout
        isLoading={this.props.isLoading}
        url={this.props.url}
        regions={this.props.regions}
        selectedRegion={this.props.selectedRegion}
        defaultInterval={this.props.defaultInterval}
        selectedInterval={this.props.selectedInterval}
        intervals={this.props.intervals}
        loadingTimeData={this.props.loadingTimeData}
        getData={this.props.fetchLoadingTime}
        changeSelectedRegion={this.props.changeSelectedRegion}
        changeSelectedInterval={this.props.changeSelectedInterval}
        monitorLocations={this.props.monitorLocations}
      />
    );
  }
}

const mapStateToProps = state => ({
  isLoading: isFetchingLoadingData(state),
  url: getSelectedWebsiteUrl(state),
  regions: getSelectedWebsiteRegions(state),
  selectedRegion: getSelectedRegion(state),
  defaultInterval: getDefaultInterval(state),
  selectedInterval: getSelectedInterval(state),
  intervals: getIntervals(state),
  loadingTimeData: getSelectedIntervalLoadingTimeData(state),
  monitorLocations: getMonitorLocations(state)
});

export default connect(mapStateToProps, {
  fetchLoadingTime,
  fetchMonitorLocations,
  changeSelectedInterval,
  changeSelectedRegion
})(SiteSpeed);
